import { mapFontSizeTypeToLineHeight, fontDisplay, StylesIndexInjections   } from 'common-react';
import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { PercentProps } from './Percent';

interface PercentStyleProps extends Pick<PercentProps, 'size'> {}

export default makeUiStyles<Theme, PercentStyleProps>((theme: Theme) =>
  createStyles({
    percent: {
      font: ({ size }) => fontDisplay('normal', theme.fontSize[size || 'base'], mapFontSizeTypeToLineHeight(size)),
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
    },
    skeleton: {
      maxWidth: 'initial'
    },
    classNameSuffix: {
      textTransform: 'none',
      paddingLeft: 4,
    }
  }), { name: 'Percent', index: StylesIndexInjections.UI_MOLECULES });

